import { Container, Grid, styled } from '@mui/material'
import { Card as BaseCard } from '@chilecompra/react-kit/components'

export const Wrapper = styled(Container)``
export const GridWrapper = styled(Grid)`
  margin: ${props => props.margin};

  &.CardGridWrapper {
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
  }

  padding: ${props => props.padding};
  text-align: ${props => props.align};
`
export const InlineLabel = styled('div')`
  color: ${props => props.theme.palette.blue[50]};
`

export const Card = styled(BaseCard)`
  &.MuiPaper-root {
    cursor: ${props => (props.onClick ? 'pointer' : 'initial')};

    & > * {
      display: grid;
      grid-template-rows: ${props => (props.rows === 1 ? 'auto' : 'auto 18px')};
      height: 100%;
      padding: 16px;
      text-align: center;
    }
  }
`

export const Link = styled('a')``
